import { useNode } from '@craftjs/core';
import { useFormContext } from 'react-hook-form';
import { useFieldState } from 'src/features/generalForms/builder/layout/panels/helpers/expression/useFieldState';
import { FormFieldOption } from 'src/features/generalForms/builder/types/BaseControlTypes';
import { FormRadioGroupInputComponent } from 'src/features/generalForms/builder/types/RadioGroupInput';
import { HookFormRadioGroupField } from 'src/features/generalForms/uikit/hookFormFields/hookFormRadioGroupField';
import { useHookFieldErrors } from 'src/helpers/error-helpers';
import { hookFormRules } from '../../../fillingModal/react-hook-form-helper';

export const FormRadioGroupInput: FormRadioGroupInputComponent = (props) => {
  const { styles } = useNode((node) => ({
    styles: node.data.custom,
  }));
  const form = useFormContext();
  const { paddingBottom, paddingLeft, paddingRight, paddingTop, ...restStyles } = styles;
  const { visible, isDisabled } = useFieldState(form);
  const errors = useHookFieldErrors(props.dataKey!);

  if (!visible) {
    return <></>;
  }

  return (
    <div style={{ paddingBottom, paddingLeft, paddingRight, paddingTop }}>
      <HookFormRadioGroupField<FormFieldOption>
        style={restStyles}
        control={form.control}
        name={props.dataKey!}
        disabled={isDisabled}
        options={props.options ?? []}
        valueField={'key'}
        labelField={'value'}
        labelProps={{
          text: props.title,
          isBold: true,
          tooltip: props.tooltip,
          description: props.description,
          isOptional: props.isOptional,
          prefix: props.prefix,
        }}
        isVertical={true}
        rules={hookFormRules({
          required: !props.isOptional && !isDisabled,
        })}
        errorProps={{ errors }}
        defaultValue={props.defaultValue}
      />
    </div>
  );
};
